import { SITE_ACOUNTS, LOGOUT } from "../../actionTypes";

const defaultState = {
    data: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SITE_ACOUNTS: {
            const { data } = action;
            return {
                ...state,
                data: data
            }
        }
        case LOGOUT:
            // Don't let the next person who logs in on this tab see the previous account list.
            return { ...state, data: [] };
        default:
            return state;
    }
};
